import { useBrowserStorage } from './useBrowserStorage.ts';

export function usePersistedNetworkFilter() {
  const [filterNetworkId] = useBrowserStorage('filterNetworkId', 'session');
  return typeof filterNetworkId === 'string' ? `?filter.networkID=${filterNetworkId}` : '';
}
